import { CurrentPage } from '../models/current-page';

export const isContactPage = (currentPage: number): boolean => currentPage === CurrentPage.Contact;

export const isProjectsPage = (currentPage: number): boolean => currentPage === CurrentPage.Projects;
